import styled from "styled-components"

import Button from '@mui/material/Button';
import CheckIcon from '@mui/icons-material/Check';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useState,useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { estadoReventa } from "../../../redux/actions/reventaActions.js";
import api from '../../../axios.js'
import { themeModules } from '../../../theme/theme.js'
import Card from "../../juegos/card.jsx"
import ModifyPricesReventa from './modifyPricesReventa.jsx'
import PricesReventa from './pricesReventa.jsx'
import ActionReventa from "./actionReventa.jsx"
import IconButton from '@mui/material/IconButton';



const Container=styled.div`
	display:inline-flex;
	border-radius:20px;
	margin:5px;
	background-color: rgba(255, 255, 255,0.1);
	font-size:13px;
	width:99vw;
	min-width:950px
	
 `;

const ContainerData=styled.div`	
	display:flex;	
	height:80%;
	width:95%;
	align-items:center
 `;

const ContainerRows=styled.div`	
	display:flex;
	flex-direction:column;
	justify-content:center;
	align-items:center;
	width:90%;
 `;

let ContainerCard=styled.div`
	min-height:100px;
	min-width:140px;
	height:20vh;
	width:10%;
`;

let TituloJuego=styled.div`
	width:90%;
	height:20%;
	display:flex;
	align-items:center;
	font-size:15px;
	font-weight:bold;
`;

let IdReventa=styled.div`
	font-weight:normal;
	margin-left:5px

`;

let DatosReventa=styled.div`
	display:flex;
	flex-direction:column;
	justify-content:space-between;
	width:20%;
	min-width:180px
`;

let TipoCuenta=styled.div`
	background-color:#808080;
	display:inline-flex;
	padding:2px;
	border-radius:5px
`;

let ContainerActionReventa=styled.div`
	width:20%;
	height:90%;
	display:flex;
	flex-direction:column;
	justify-content:space-between;
	align-items:end;
`;
let ContainerSavePrices=styled.div`
	display:flex;
	flex-direction:column;
	height:80%;
	justify-content:space-around;
`;






 export default function RowReventa(props){
 	let { data,estado }=props;
 	let [ reventa,setReventa ] = useState(data);
 	let [ modify,setModify ] = useState(false); 

 	let dispatch=useDispatch();
 	let [ nuevosPrecios,setNuevosPrecios ] = useState({	Peru:reventa.precio_peru,
 														Dolar:reventa.precio_resto,
 														Argentina:reventa.precio_argentina,
 														Bolivia:reventa.precio_bolivia,
 														Chile:reventa.precio_chile,
 														Colombia:reventa.precio_colombia,
 														Mexico:reventa.precio_mexico,
 														Uruguay:reventa.precio_uruguay
 													}); 	
 	

 	useEffect(()=>{
 		setReventa(data);
 	},[data]);

 	

 	let handleClickModify=()=>{
 		setModify(!modify)
 	}

 	let saveChanges=async()=>{
 		if(window.confirm("guardar los cambios de precio")){
 			dispatch(estadoReventa(2))
 			let newPrices = new FormData();
 			newPrices.append('id',reventa.id)
 			newPrices.append('precio_peru',nuevosPrecios.Peru);
 			newPrices.append('precio_resto',nuevosPrecios.Dolar);
 			newPrices.append('precio_argentina',nuevosPrecios.Argentina);
 			newPrices.append('precio_bolivia',nuevosPrecios.Bolivia);
 			newPrices.append('precio_chile',nuevosPrecios.Chile);
 			newPrices.append('precio_colombia',nuevosPrecios.Colombia)
 			newPrices.append('precio_mexico',nuevosPrecios.Mexico);
 			newPrices.append('precio_uruguay',nuevosPrecios.Uruguay);

 			try{ 			
	 			await api.patch(`/reventa`,newPrices );
	 			alert("se dejo de revender juego");
	 			dispatch(estadoReventa(0));
	 			handleClickModify();
	 		}catch(err){
	 			console.log(err);
	 			alert("error");
	 			dispatch(estadoReventa(0))
	 		}
 		}		
 	}



 	 	return(<div>
 		{reventa?
 		<Container style={{backgroundColor:themeModules.panel}} > 
 			<ContainerCard>
 				<Card consola={reventa.consola} poster={reventa.Cuenta_Juego.Juego.poster}/>
 			</ContainerCard>			
 			
      		<ContainerRows>
      			<TituloJuego>{reventa.Cuenta_Juego.Juego.nombre} <IdReventa> ({reventa.id})</IdReventa></TituloJuego>
 				<ContainerData>
 					<DatosReventa>
 						<div>tipo de cuenta :<TipoCuenta> {reventa.tipo_cuenta}</TipoCuenta> </div>
 						<div>usuario :  {reventa.User.usuario}</div>
 						<div>nombre usuario :  {reventa.User.name}</div>
 						<div>correo cuenta playStation : {reventa.Cuenta_Juego.Cuentum.correo}</div>
 					</DatosReventa>
 			{modify?<ModifyPricesReventa reventa={reventa} setNuevosPrecios={setNuevosPrecios} nuevosPrecios={nuevosPrecios}/>
 					:<PricesReventa reventa={reventa} />}
		 	{!modify?<Button variant="contained" sx={{width:"65px"}} color={"primary"} onClick={handleClickModify} disabled={estado} >modificar</Button>
		 			:<ContainerSavePrices>
		 				<IconButton style={{display:!reventa.permiso?"flex":"none"}} aria-label="vendido" id={reventa.id}  onClick={saveChanges}>
        					<CheckIcon style={{color:!reventa.vendido?"green":"gray"}} id={reventa.id} />
      					</IconButton>
 						<IconButton aria-label="eliminar" id={reventa.id} onClick={handleClickModify}>
        					<DeleteOutlineIcon style={{color:!reventa.vendido?"#BB0E0E":"gray" }} />        		
      					</IconButton >
		 			</ContainerSavePrices>}
		 	{!modify?<ContainerActionReventa>
		 				<ActionReventa reventa={reventa}/>
 					</ContainerActionReventa>
 				:null}		
 				</ContainerData>
 			</ContainerRows> 			
      	</Container>
      	:null}
      	</div>
 		

 		)
 }